(function () {
    angular
        .module('sodCommon')
        .filter('sortObjArrToArrBySamplingData', sortObjArrToArrBySamplingData);

    function sortObjArrToArrBySamplingData(lodash) {
        return function (toBeSorted, samplingData, orderBy, key) {
            var sortedSamplingData = lodash.orderBy(samplingData, orderBy[0], orderBy[1]);
            if (lodash.isArray(toBeSorted)) {
                return lodash.map(sortedSamplingData, function(_sortedSamplingData) { return lodash.get(_sortedSamplingData, key); });
            } else {
                return lodash.reduce(sortedSamplingData, function(carry, _sortedSamplingData) {
                    var _key = lodash.get(_sortedSamplingData, key);
                    return carry.concat([lodash.get(toBeSorted, _key)]);
                }, []);
            }
        };
    }
})();